import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const usePwaStore = defineStore('pwaStore', () => {
  const deferredPrompt = ref();

  const hasDeferredPrompt = computed(() => !!deferredPrompt.value);

  async function showInstallPrompt() {
    deferredPrompt.value.prompt();
    const { outcome } = await deferredPrompt.value.userChoice;

    window.happitDataLayer.push({
      event: 'pwa_install_prompt_native',
      outcome,
    });
  }

  return {
    deferredPrompt,
    hasDeferredPrompt,
    showInstallPrompt,
  };
});
